import { config } from '_/config/config';

export const pLog = (...message) => {
    if (!config.ENV.debug) {
        return;
    }

    console.info('[Photon CMS info] ', message);
};

export const pError = (...message) => {
    if (!config.ENV.debug) {
        return;
    }

    console.error('[Photon CMS error] ', message);
};

export const pWarn = (...message) => {
    if (!config.ENV.debug) {
        return;
    }

    console.warn('[Photon CMS warn] ', message);
};
